import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AclService } from '@services/acl/acl.service';
import { AppLog } from '@app/core/services';
import { LogPriority } from '@services/log/log-priority.enum';
import { AuthStore } from '@app/store/auth.store';
import { AuthenticationService } from '@app/core/services/backend/authentication.service';
import { Location } from '@angular/common';

export const AclGuard: CanActivateFn = async (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authStore = inject(AuthStore),
    logger: AppLog = inject(AppLog),
    aclService: AclService = inject(AclService),
    location: Location = inject(Location),
): Promise<boolean> => {
    if (!authStore.identity()) {
        const hasToken = !!sessionStorage.getItem(AuthenticationService.authTokenStoreKey);
        if (hasToken) {
            await authStore.identityReady();
        }
    }

    if (!authStore.isAuthenticated()) {
        return false;
    }
    const hasAccess = aclService.hasRouteAccess(state.url);
    if (!hasAccess) {
        logger.warning(
            'User trying to access a restricted area ',
            { logPriority: LogPriority.MEDIUM },
            { url: state.url },
        );
        location.back();
    }
    return hasAccess;
};
